(function () {
  const token = 'c6d2c8e3e0b277b202e415f6d588764c';
  const title = window.__blogTitle || '';
  const storeDomain = window.Shopify.shop;

  const TAG_MAP = {
    'urinary tract and bladder supplement': 'UTI SUPPLEMENT',
    'uti supplement': 'UTI SUPPLEMENT',
    'uti': 'UTI SUPPLEMENT',
    'salve': 'Salve',
    'suppository': 'Suppository',
    'probiotic': 'Probiotic',
    'tonic': 'Tonic',
    'hydrosol': 'Hydrosol',
    'body oil': 'Body Oil',
    'bath soak': 'body care',
  };

  function mapTag(tag) {
    return TAG_MAP[tag.toLowerCase()] || tag;
  }

  function processShortcodes() {
    const paragraphs = document.querySelectorAll('p');
    paragraphs.forEach(p => {
      if (p.innerText.trim().includes('[product-slider]')) {
        const div = document.createElement('div');
        div.className = 'product-slider-embed';
        div.dataset.token = token;
        p.parentNode.replaceChild(div, p);
      }
    });
  }

  async function fetchProducts(query, sliderToken) {
    const response = await fetch(`https://${storeDomain}/api/2024-01/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': sliderToken
      },
      body: JSON.stringify({
        query: `{
          products(first: 3, query: "${query}") {
            edges {
              node {
                id title
                priceRange { minVariantPrice { amount currencyCode } }
                compareAtPriceRange { minVariantPrice { amount } }
                featuredImage { url altText }
                variants(first: 1) { edges { node { id compareAtPrice { amount } price { amount } } } }
                onlineStoreUrl
              }
            }
          }
        }`
      })
    });
    const data = await response.json();
    return data.data.products.edges.map(e => e.node);
  }

  async function initSlider(slider) {
    const rawTags = (window.__blogTags || '').split(',').map(t => t.trim()).filter(Boolean);
    const tags = rawTags.map(mapTag);
    const sliderToken = slider.dataset.token;
    let products = [];

    if (tags.length) {
      const tagQuery = tags.map(t => `tag:'${t}'`).join(' OR ');
      products = await fetchProducts(tagQuery, sliderToken);
    }
    if (!products.length && title) {
      const keyword = title.split(' ').slice(0, 3).join(' ');
      products = await fetchProducts(`title:*${keyword}*`, sliderToken);
    }
    if (!products.length) { slider.style.display = 'none'; return; }
    render(slider, products);
  }

  function render(slider, products) {
    slider.innerHTML = `
      <div class="pse-wrapper">
        <button class="pse-btn pse-prev" aria-label="Previous">&#8592;</button>
        <div class="pse-track">
          ${products.map(p => {
            const variant = p.variants.edges[0].node;
            const price = parseFloat(variant.price.amount).toFixed(2);
            const compareAt = variant.compareAtPrice ? parseFloat(variant.compareAtPrice.amount).toFixed(2) : null;
            const priceHtml = compareAt && compareAt > price
              ? `<p class="pse-price"><s class="pse-compare">$${compareAt}</s> <span class="pse-sale">$${price}</span></p>`
              : `<p class="pse-price">$${price}</p>`;
            return `
              <div class="pse-card">
                <a href="${p.onlineStoreUrl}">
                  <img src="${p.featuredImage?.url || ''}" alt="${p.featuredImage?.altText || p.title}" loading="lazy" />
                  <h3>${p.title}</h3>
                  ${priceHtml}
                </a>
                <form action="/cart/add" method="post">
                  <input type="hidden" name="id" value="${p.variants.edges[0].node.id.split('/').pop()}">
                  <button type="submit" class="pse-atc">Add to Cart</button>
                </form>
              </div>`;
          }).join('')}
        </div>
        <button class="pse-btn pse-next" aria-label="Next">&#8594;</button>
      </div>
      <style>
        .product-slider-embed { margin: 40px 0; }
        .pse-wrapper { display:flex; align-items:center; justify-content:center; gap:12px; font-family:inherit; }
        .pse-track {
          display:flex; gap:16px; overflow-x:auto; scroll-behavior:smooth;
          -webkit-overflow-scrolling:touch; scrollbar-width:none;
          scroll-snap-type:x mandatory;
        }
        .pse-track::-webkit-scrollbar { display:none; }
        .pse-card {
          min-width:220px; flex-shrink:0; background:#faf9f7;
          border:1px solid #e8e2d9; border-radius:8px; padding:16px;
          text-align:center; scroll-snap-align:start;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }
        .pse-card:hover { transform: translateY(-4px); box-shadow: 0 8px 24px rgba(0,0,0,0.1); }
        .pse-card img { width:100%; height:180px; object-fit:cover; border-radius:6px; }
        .pse-card h3 { font-size:14px; margin:10px 0 4px; color:#2c2c2c; }
        .pse-price { font-size:13px; color:#7a6a5a; margin-bottom:10px; }
        .pse-compare { color:#aaa; font-size:12px; margin-right:4px; }
        .pse-sale { color:#c0392b; font-weight:600; }
        .pse-atc {
          background:#2c2c2c; color:#fff; border:none; padding:8px 16px;
          border-radius:4px; cursor:pointer; font-size:13px; width:100%;
        }
        .pse-atc:hover { background:#4a3f35; }
        .pse-btn {
          background:none; border:1px solid #ccc; border-radius:50%;
          width:36px; height:36px; cursor:pointer; font-size:18px; flex-shrink:0;
        }
        @media (max-width: 768px) {
          .pse-btn { display:none; }
          .pse-card { min-width:85vw; }
        }
      </style>
    `;

    const track = slider.querySelector('.pse-track');
    const prevBtn = slider.querySelector('.pse-prev');
    const nextBtn = slider.querySelector('.pse-next');

    if (products.length < 3) {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
    }

    prevBtn.addEventListener('click', () => track.scrollBy({ left: -250, behavior: 'smooth' }));
    nextBtn.addEventListener('click', () => track.scrollBy({ left: 250, behavior: 'smooth' }));
  }

  function run() {
    processShortcodes();
    const sliders = document.querySelectorAll('.product-slider-embed');
    if (!sliders.length) return;
    sliders.forEach(slider => initSlider(slider));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

})();
